import React, {useState, useEffect} from 'react';
import apiFetch from '@wordpress/api-fetch';
import {useForm} from 'react-hook-form';
import {Markup} from 'interweave';
import FormAlert from '../../components/FormAlert'
import ReactRecaptcha3 from 'react-google-recaptcha3';

function App(props) {
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const {register, setValue, handleSubmit, formState: {errors}} = useForm();

  useEffect(() => {
    ReactRecaptcha3.init(vetnode.google_recaptcha.site_key)
  }, [])

  const handleFormSubmit = (data) => {
    if (!isSending) {
      sendForm(data);
    }
  };

  const sendForm = (formData) => {
    setIsSending(true);

    ReactRecaptcha3.getToken().then(token => {
      formData['post_id'] = vetnode_form_contact.post_id;
      formData[vetnode.google_recaptcha.input_name] = token;

      apiFetch({
        path: vetnode.api_path + '/form/contact/',
        method: 'POST',
        data: formData,
      })
        .then((response) => {
          setSuccess(response.success);
          setMessage(response.message);
          setSubmitted(response.success);
          setIsSending(false)
        });
    }, error => {
      alert(error);
    })
  };

  if (submitted && success) {
    return (
      <FormAlert
        type="success"
        message={message}
      />
    )
  }

  return (
    <>
      {message &&
        <FormAlert
          type="error"
          message={message}
        />
      }

      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="form__item">
          <label htmlFor="name" className="form__label">
            {vetnode.form.fields.name.label}
            <span className="form__required">*</span>
          </label>
          <input type="text" id="name" required
                 className={"form__input " + (errors.name ? 'form__input--with-error' : '')}
                 placeholder={vetnode.form.fields.name.placeholder}
                 {...register('name', {
                   required: vetnode.form.validation.required,
                 })} />
          {errors.name && <div className="form__error">{errors.name.message}</div>}
        </div>
        <div className="form__item">
          <label htmlFor="email" className="form__label">
            {vetnode.form.fields.email.label}
            <span className="form__required">*</span>
          </label>
          <input type="email" id="email" required
                 className={"form__input " + (errors.email ? 'form__input--with-error' : '')}
                 placeholder={vetnode.form.fields.email.placeholder}
                 {...register('email', {
                   required: vetnode.form.validation.required,
                   pattern: {
                     value: /\S+@\S+\.\S+/,
                     message: vetnode.form.validation.email,
                   }
                 })} />
          {errors.email && <div className="form__error">{errors.email.message}</div>}
        </div>
        <div className="form__item">
          <label htmlFor="message" className="form__label">
            {vetnode.form.fields.message.label}
            <span className="form__required">*</span>
          </label>
          <textarea id="message" required
                    className={"form__input form__textarea " + (errors.message ? 'form__input--with-error' : '')}
                    placeholder={vetnode.form.fields.message.placeholder}
                    {...register('message', {
                      required: vetnode.form.validation.required,
                    })} ></textarea>
          {errors.message && <div className="form__error">{errors.message.message}</div>}
        </div>

        <div className="form__note">
          <Markup content={vetnode_form_contact.terms_label} noWrap={true}/>
        </div>

        <div className="form__button">
          <button className="button button--primary">
            {isSending ? (
              <span>{vetnode.form.button.submitting}</span>
            ) : (
              <span>{vetnode.form.button.text}</span>
            )}
          </button>
        </div>
      </form>
    </>
  );
}

export default App;
